module.exports = __webpack_public_path__ + "img/ic_graduation_icon.1df86bff.svg";